import PropTypes from 'prop-types';
import React from 'react';
import { Button, ControlLabel, FormControl } from 'react-bootstrap';
import { List } from 'immutable';
import { Secret } from '../../stores/SecretStore';
import SecretActions from '../../actions/SecretActions';
import { resourceNameDisplay } from './util';

export const ResourceSelect = ({ credential, resources, onResourceChange }) => (
  <div className='edit-secret-form-item'>
    <ControlLabel>Resource</ControlLabel>
    <FormControl
      componentClass='select'
      value={credential.resourceId || -1}
      onChange={onResourceChange}
    >
      <option key={-1} value={-1}>
        Select Resource...
      </option>
      {resources.map(resource => (
        <option key={resource.id} value={resource.id}>
          {resourceNameDisplay(resource)}
        </option>
      ))}
    </FormControl>
  </div>
);

ResourceSelect.propTypes = {
  credential: PropTypes.instanceOf(Secret),
  resources: PropTypes.instanceOf(List),
  onResourceChange: PropTypes.func,
};

export const SecretKeyInput = ({ credential, onUpdateSecretKey }) => (
  <div className='edit-secret-form-item'>
    <ControlLabel>Username</ControlLabel>
    <FormControl
      type='text'
      value={credential.secretKey || ''}
      className='secondary-input'
      onChange={onUpdateSecretKey}
    />
  </div>
);

SecretKeyInput.propTypes = {
  credential: PropTypes.instanceOf(Secret),
  onUpdateSecretKey: PropTypes.func,
};

export const SecretValueInput = ({ credential, onUpdateSecretValue }) => (
  <div className='edit-secret-form-item'>
    <ControlLabel>Password</ControlLabel>
    <FormControl
      type='password'
      placeholder={credential.id !== -1 ? 'Blank will not override' : ''}
      value={credential.secretValue || ''}
      className='secondary-input'
      onChange={onUpdateSecretValue}
    />
  </div>
);

SecretValueInput.propTypes = {
  credential: PropTypes.instanceOf(Secret),
  onUpdateSecretValue: PropTypes.func,
};

export const SecretNameInput = ({ credential, onUpdateSecretName }) => (
  <div className='edit-secret-form-item'>
    <ControlLabel>Nickname (optional)</ControlLabel>
    <FormControl
      type='text'
      value={credential.secretName || ''}
      className='secondary-input'
      onChange={onUpdateSecretName}
    />
  </div>
);

SecretNameInput.propTypes = {
  credential: PropTypes.instanceOf(Secret),
  onUpdateSecretName: PropTypes.func,
};

export const EditCredentialActionButtons = ({ credential, exitEditMode }) => {
  const onSave = () => {
    SecretActions.saveSecret(credential);
    exitEditMode();
  };

  const exitEditModeAndRemoveUnsavedSecret = () => {
    if (credential.id === -1) {
      SecretActions.removeUnsavedSecret();
    }
    exitEditMode();
  };

  const onDelete = () => {
    /* eslint-disable */
    if (confirm(`Are you sure you want to delete ${credential.secretName ? credential.secretName : credential.secretKey}?`)) {
    /* eslint-enable */
      SecretActions.deleteSecret(credential.id);
    }
  };

  return (
    <div className='credential-buttons'>
      {
        credential.id !== -1 &&
          <div className='credential-button'>
            <Button
              bsStyle='danger'
              onClick={onDelete}
            >
              Delete
            </Button>
          </div>
      }
      <div className='credential-button'>
        <Button
          bsStyle='basic'
          onClick={exitEditModeAndRemoveUnsavedSecret}
        >
          Cancel
        </Button>
      </div>
      <div className='credential-button'>
        <Button
          bsStyle='primary'
          onClick={onSave}
          disabled={!credential.valid}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

EditCredentialActionButtons.propTypes = {
  credential: PropTypes.instanceOf(Secret),
  exitEditMode: PropTypes.func,
};
